import { ReactNode } from 'react';
import { cn } from '@/shared/lib/utils';

interface SectionProps {
  children: ReactNode;
  className?: string;
  spacing?: 'sm' | 'md' | 'lg' | 'xl';
  background?: 'transparent' | 'white' | 'gray' | 'gradient';
  border?: boolean;
  rounded?: boolean;
}

/**
 * セクション区切りコンポーネント
 * 一貫したスペーシング、背景、境界線を提供
 */
export const Section: React.FC<SectionProps> = ({
  children,
  className,
  spacing = 'md',
  background = 'transparent',
  border = false,
  rounded = false
}) => {
  const spacingClasses = {
    sm: 'py-fluid-sm',
    md: 'py-fluid-md',
    lg: 'py-fluid-lg',
    xl: 'py-fluid-xl'
  };

  const backgroundClasses = {
    transparent: '',
    white: 'bg-white dark:bg-gray-900',
    gray: 'bg-gray-50 dark:bg-gray-800',
    gradient: 'bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-800'
  };

  return (
    <section
      className={cn(
        spacingClasses[spacing],
        backgroundClasses[background],
        border && 'border border-gray-200 dark:border-gray-700',
        rounded && 'rounded-lg',
        className
      )}
    >
      {children}
    </section>
  );
};